<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pxii"></a><a class="xref" href="#/eerlucas0006#rabbrs">Abbreviations</a></h1>
<div class="glossary">
<p class="glo"><span class="gt">AB</span> Anchor Bible</p>
<p class="glo"><span class="gt-i">AEL</span> <i>Ancient Egyptian Literature,</i> M. Lichtheim. 3 vols. Berkley, CA: University of California Press, 1971-80</p>
<p class="glo"><span class="gt-i">AJSL</span> <i>American Journal of Semitic Languages and Literatures</i></p>
<p class="glo"><span class="gt">Aq</span> Aquila’s Greek translation of Proverbs</p>
<p class="glo"><span class="gt-i">AUSS</span> <i>Andrews University Seminary Studies</i></p>
<p class="glo"><span class="gt">BETL</span> Bibliotheca Ephemeridum Theologicarum Lovaniensium</p>
<p class="glo"><span class="gt-i">Bib</span> <i>Biblica</i></p>
<p class="glo"><span class="gt">BKAT</span> Biblischer Kommentar: Altes Testamentum</p>
<p class="glo"><span class="gt">BNTC</span> Black’s New Testament Commentaries</p>
<p class="glo"><span class="gt-i">BTS</span> <i>Bible et terre sainte</i></p>
<p class="glo"><span class="gt-i">BWL</span> <i>Babylonian Wisdom Literature,</i> W. G. Lambert. Winona Lake, IN: Eisenbrauns, 1996</p>
<p class="glo"><span class="gt">BZAW</span> Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft</p>
<p class="glo"><span class="gt-i">CAD</span> <i>The Assyrian Dictionary of the Oriental Institute of the University of Chicago.</i> Chicago, 1956-2006</p>
<p class="glo"><span class="gt-i">CBQ</span> <i>Catholic Biblical Quarterly</i></p>
<p class="glo"><span class="gt-i">COS</span> <i>The Context of Scripture.</i> Edited by W. W. Hallo. Leiden: Brill, 1997-2002</p>
<p class="glo"><span class="gt">ESV</span> English Standard Version</p>
<p class="glo"><span class="gt-i">ETL</span> <i>Ephemerides Theologicae Lovanienses</i></p>
<p class="glo"><span class="gt">EVV</span> English versions</p>
<p class="glo"><span class="gt">GKC</span> <i>Gesenius’ Hebrew Grammar.</i> Edited by E. Kautzsch. Translated by A. E. Cowley. 2nd ed. Oxford: OUP, 1910</p>
<p class="glo"><span class="gt">GNB</span> Good News Bible</p>
<p class="glo"><span class="gt-i">HS</span> <i>Hebrew Studies</i></p>
<p class="glo"><span class="gt-i">Int</span> <i>Interpretation</i></p>
<p class="glo"><a class="page" id="pxiii"></a><span class="gt-i">JANESCU</span> <i>Journal of the Ancient Near Eastern Society of Columbia University</i></p>
<p class="glo"><span class="gt-i">JBL</span> <i>Journal of Biblical Literature</i></p>
<p class="glo"><span class="gt-i">JETS</span> <i>Journal of the Evangelical Theological Society</i></p>
<p class="glo"><span class="gt-i">JNSL</span> <i>Journal of Northwest Semitic Languages</i></p>
<p class="glo"><span class="gt">Joüon</span> Joüon, P. A. <i>A Grammar of Biblical Hebrew.</i> Translated and revised by T. Muraoka. 2 vols. Subsidia biblical 14/1-2. Rome: Editrice Pontificio Istituto Biblico, 1993 (corrected edition)</p>
<p class="glo"><span class="gt-i">JQR</span> <i>Jewish Quarterly Review</i></p>
<p class="glo"><span class="gt-i">JSOT</span> <i>Journal for the Study of the Old Testament</i></p>
<p class="glo"><span class="gt">JSOTSup</span> Journal for the Old Testament: Supplement Series</p>
<p class="glo"><span class="gt-i">JTS</span> <i>Journal of Theological Studies</i></p>
<p class="glo"><span class="gt">K</span> Kethibh (the written Hebrew text of the MT)</p>
<p class="glo"><span class="gt">KJV</span> King James Version</p>
<p class="glo"><span class="gt">LXX</span> Septuagint</p>
<p class="glo"><span class="gt">ms(s)</span> manuscript(s)</p>
<p class="glo"><span class="gt">MT</span> Massoretic Text</p>
<p class="glo"><span class="gt">NAB</span> New American Bible</p>
<p class="glo"><span class="gt">NCB</span> New Century Bible</p>
<p class="glo"><span class="gt">NICOT</span> New International Commentary on the Old Testament</p>
<p class="glo"><span class="gt-i">NIDNTT</span> <i>New International Dictionary of New Testament Theology</i></p>
<p class="glo"><span class="gt-i">NIDOTTE</span> <i>New International Dictionary of Old Testament Theology and Exegesis</i></p>
<p class="glo"><span class="gt">NIGTC</span> New International Greek Testament Commentary</p>
<p class="glo"><span class="gt">NIV</span> New International Version</p>
<p class="glo"><span class="gt">NIVAC</span> New International Version Application Commentary</p>
<p class="glo"><span class="gt">NJPSV</span> New Jewish Publication Society Version (2nd ed.)</p>
<p class="glo"><span class="gt">NRSV</span> New Revised Standard Version</p>
<p class="glo"><span class="gt">NT</span> New Testament</p>
<p class="glo"><span class="gt">OT</span> Old Testament</p>
<p class="glo"><span class="gt">OTL</span> Old Testament Library</p>
<p class="glo"><span class="gt-i">OTP</span> <i>The Old Testament Pseudepigrapha.</i> J. H. Charlesworth (ed.). 2 vols. Garden City, NY: Doubleday, 1983-85</p>
<p class="glo"><span class="gt">Q</span> Qere (the Hebrew text to be read out from the MT)</p>
<p class="glo"><span class="gt-i">RB</span> <i>Revue biblique</i></p>
<p class="glo"><span class="gt">REB</span> Revised English Bible</p>
<p class="glo"><span class="gt-i">SBFLA</span> <i>Studii Biblici Fransiscani Liber Annus</i></p>
<p class="glo"><span class="gt">SBLDS</span> Society of Biblical Literature Dissertation Series</p>
<p class="glo"><span class="gt">Sym</span> Symmachus’ Greek translation of Proverbs</p>
<p class="glo"><span class="gt">Syr</span> Syriac</p>
<p class="glo"><a class="page" id="pxiv"></a><span class="gt">Targ</span> Targum</p>
<p class="glo"><span class="gt">Theod</span> Theodotion’s Greek translation of Proverbs</p>
<p class="glo"><span class="gt">TOTC</span> Tyndale Old Testament Commentary</p>
<p class="glo"><span class="gt-i">TynB</span> <i>Tyndale Bulletin</i></p>
<p class="glo"><span class="gt-i">VT</span> <i>Vetus Testamentum</i></p>
<p class="glo"><span class="gt">VTSup</span> Supplements to Vetus Testamentum</p>
<p class="glo"><span class="gt">Vulg</span> Vulgate</p>
<p class="glo"><span class="gt">WMANT</span> Wissenschaftliche Monographien zum Alten un Neuen Testament</p>
<p class="glo"><span class="gt-i">WO</span> <i>Die Welt des Orient</i></p>
<p class="glo"><span class="gt-i">ZAH</span> <i>Zeitschrift für Althebräistik</i></p>
<p class="glo"><span class="gt-i">ZAW</span> <i>Zeitschrift für die alttestamentliche Wissenschaft</i></p>
<p class="glo"><span class="gt-i">ZTK</span> <i>Zeitschrift für Theologie und Kirche</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-lucas-0008.vue?99961ebc